import { useState } from 'react'

import ConfirmationDialog from '../../../components/ReusableComponents/ConfirmationDialog/index'
import TextInput from '../../../components/ReusableComponents/ManageHotel/TextInput/index'
import Toggle from '../../../components/ReusableComponents/Toggle/index'
import styles from './EditBillingDetailsDialog.module.scss'

const EditBillingDetailsDialog = props => {
  const [invoiceReconcileInDays, setInvoiceReconcileInDays] = useState(
    props.invoiceReconcileInDays
  )

  const [invoicePayInDays, setInvoicePayInDays] = useState(props.invoicePayInDays)
  const [isAutoPayEnabled, setIsAutoPayEnabled] = useState(props.isAutoPayEnabled)

  return (
    <ConfirmationDialog
      title="Edit billing details"
      theme="blacklist"
      positiveMessage="Save changes"
      onConfirm={() =>
        props.handleConfirm({
          invoicePayInDays,
          invoiceReconcileInDays,
          isAutoPayEnabled
        })
      }
      onClose={props.handleClose}
    >
      <div className={styles.container}>
        <TextInput
          label="Reconciliation period (days)"
          value={invoiceReconcileInDays}
          onChange={e => setInvoiceReconcileInDays(e.target.value.replace(/\D/g, ''))}
        />
        <TextInput
          label="Payment period (days)"
          value={invoicePayInDays}
          onChange={e => setInvoicePayInDays(e.target.value.replace(/\D/g, ''))}
        />
        <div className={styles.label}>Auto Payments</div>
        <div className={styles.value}>
          <Toggle
            label={isAutoPayEnabled ? 'Enabled' : 'Disabled'}
            checked={isAutoPayEnabled}
            handleChange={e => setIsAutoPayEnabled(e.target.checked)}
          />
        </div>
      </div>
    </ConfirmationDialog>
  )
}

export default EditBillingDetailsDialog
